import { UploadedDocument } from "../../../../../../types/document";
import { vehicleTypesOptions } from "../../../../../libs/constants";
import { findSelectOption } from "../../../../../libs/utils";
import { Vehicle } from "./types";
import { VehicleForm } from "./VehicleDetailForm";

export function mapVehicleToForm(vehicle?: Vehicle): VehicleForm {
  if (!vehicle)
    return {
      vehicleId: null,
      typeOfVehicle: null,
      brand: null,
      model: null,
      modelYear: null,
      color: null,
      city: null,
      plateCode: null,
      plateNumber: null,
      document: null,
    };

  return {
    vehicleId: vehicle.vehicleId,
    typeOfVehicle: findSelectOption(vehicleTypesOptions, vehicle.typeOfVehicle),
    brand: vehicle.brand,
    model: vehicle.model,
    modelYear: vehicle.modelYear,
    color: vehicle.color,
    city: { label: vehicle.city, value: vehicle.city },
    plateCode: vehicle.plateCode,
    plateNumber: vehicle.plateNumber,
    document: { documentId: vehicle.documentId } as UploadedDocument,
  };
}
